import React, { Component } from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PostCard from "../components/PostCard"
import CategoryMenu from "../components/CategoryMenu"

const PostCardList = styled.div`
  margin: 0 0 100px 0;
`

class IndexPage extends Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges
    // const { location } = this.props

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Home" />
        <CategoryMenu />
        <PostCardList>
          {posts.map(({ node }) => {
            return <PostCard key={node.id} node={node} />
          })}
        </PostCardList>
      </Layout>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: frontmatter___date, order: DESC }) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "YYYY/MM/DD")
            category
            description
            featured
          }
          id
          excerpt
        }
      }
    }
  }
`
